export default "__VITE_ASSET__oKE90fQ0__"